export const MENU_KEYS = {
  navVisible: "navbar.visible",
  navLinks: "navbar.links",
  shopVisible: "footershop.visible",
  shopLinks: "footershop.links",
};

const NAV_SLUGS = new Set(["chaniya-choli", "womens-fashion", "mens-fashion", "kids", "accessories", "gift-articles", "trending"]);

export const DEFAULT_SHOP_LINKS = [
  { name: "Chaniya Choli", url: "/category/chaniya-choli" },
  { name: "Men's Fashion", url: "/category/mens-fashion" },
  { name: "Kids", url: "/category/kids" },
  { name: "Accessories", url: "/category/accessories" },
];

export const defaultNavLinks = (cats) => [
  ...cats
    .filter((c) => !c.parent_slug && NAV_SLUGS.has(c.slug))
    .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0))
    .map((c) => ({ name: c.name, url: `/category/${c.slug}` })),
  { name: "About", url: "/about" },
];

export const parseLinks = (raw, fallback) => {
  if (raw === undefined || raw === null || raw === "") return fallback;
  try {
    const v = JSON.parse(raw);
    return Array.isArray(v) ? v.filter((l) => l && l.name && l.url) : fallback;
  } catch { return fallback; }
};

export const isExternal = (url) => /^(https?:|mailto:|tel:)/i.test(url || "");

export const categorySlugOf = (url) => {
  const m = /^\/category\/([^/?#]+)/.exec(url || "");
  return m ? m[1] : null;
};

export const slugify = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
